<template>
	<div
		v-if="printPreview"
		class="print-header__container"
	>
		<div class="print-header__title">{{ title }}</div>
		<div class="print-header__branch-info">
			<span>{{ address }}</span>
			<span v-if="phone">Telefon&nbsp;{{ phone }}</span>
			<span>{{ email }}</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { isPrintPreview } from '@helper/composables/printPreview';

interface Props {
	title?: string;
	address?: string;
	phone?: string;
	email?: string;
}

withDefaults(defineProps<Props>(), {
	title: '',
	address: '',
	phone: '',
	email: '',
});

const { printPreview } = isPrintPreview();
</script>

<style lang="scss" scoped>
.print-header {
	&__branch-info {
		display: flex;
		flex-flow: column;
		font-size: $font-small-1;
		line-height: 2.4rem;
	}

	&__container {
		text-align: right;
		position: absolute;
		top: 0;
		right: 0.5cm;
		z-index: 9999;
	}

	&__title {
		font-size: $font-medium-2;
		margin-bottom: $spacer-6;
	}
}
</style>
